// The first screen after sign-in: credits, a first question, and code. See
// Design > Names and definitions, "The Console".

import { Button, List, ListRow, PageHeader } from "../../../../ui/src/index.ts";
import { usd } from "../../domain/money.ts";
import { openCredits } from "../actions.ts";
import { href, navigate } from "../router.ts";
import { useStore } from "../store.ts";
import { PublicFrame } from "./Landing.tsx";

// Credits opens over the signed-in frame, so go Home first.
const seeCredits = () => { navigate("home"); openCredits(); };

const Step = ({ n, children }: { n: number; children: string }) => <><span class="cs-steps__num">{n}</span>{children}</>;

export function Welcome() {
  const balance = useStore((s) => s.balance);
  const lessons = useStore((s) => s.content.lessons.length);
  return (
    <PublicFrame home="home">
      <div class="cs-public__inner cs-welcome">
        <p class="cs-label">Signed in</p>
        <PageHeader title={<><strong>Welcome</strong>.</>} description="You're signed in with WarmHub. Here's what you have and where to start." />
        <List class="cs-steps">
          <ListRow
            name={<Step n={1}>Your credits</Step>}
            sub={<>{balance === null
              ? "You use simulated credits. Your balance shows in the navigation after your first request."
              : <>You have <span class="mono">{usd(balance)}</span> in simulated credits.</>} You can see every charge, and top off, in Credits.</>}
            aside={<Button onClick={seeCredits}>See credits</Button>}
          />
          <ListRow
            name={<Step n={2}>Your first question</Step>}
            sub={`The Playground walks you through a request, a bid and an answer in ${lessons} short lessons.`}
            aside={<Button variant="solid" href={href("playground/first")}>Open the Playground</Button>}
          />
          <ListRow
            name={<Step n={3}>Your code</Step>}
            sub="Call the Consumer API from your own code with a WarmHub token. Copy any Playground request as an API call."
            aside={<Button href={href("home")}>Go to Home</Button>}
          />
        </List>
        <div class="cs-welcome__skip"><Button variant="ghost" href={href("home")}>Skip to the Console</Button></div>
      </div>
    </PublicFrame>
  );
}
